import { render, staticRenderFns } from "./ReportingPage.vue?vue&type=template&id=41788c32"
import script from "./ReportingPage.vue?vue&type=script&lang=js"
export * from "./ReportingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports